import './style.scss';
import { DatePicker } from 'antd';
import getFormatMessage from '../../../../locales/get-format-message';
import { IAPIStudioInfo } from '../../../../model/api-modules/studio';
import { useState, useEffect } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { BillingManagementDetails } from './billing-management-details';
import { BillingManagementOverview } from './billing-management-overview';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
}

export const BillingManagement = (props: IProps) => {
  const studioId = props.studioInfo.studio.StudioID;
  const [isDateRangeSelected, setIsDateRangeSelected] =
    useState<boolean>(false);
  const [dateRange, setDateRange] = useState<string>('');
  const [tabKey, setTabKey] = useState<number>(0);

  useEffect(() => {
    const currentMonth = moment().subtract(1, 'months').format('YYYY-MM');
    setDateRange(currentMonth);
    setIsDateRangeSelected(true);
  }, []);

  const changeTabKey = async (key: number) => {
    setTabKey(key);
  };

  const handleDateChange = (dates: any, dateStrings: string) => {
    if (!dates || dates.length === 0) {
      setDateRange('');
      setIsDateRangeSelected(false);
    } else {
      setDateRange(dateStrings);
      setIsDateRangeSelected(true);
    }
  };

  const renderOverview = () => {
    if (tabKey === 0) {
      return (
        <BillingManagementOverview studioId={studioId} dateRange={dateRange} />
      );
    }
  };

  const renderDetails = () => {
    if (tabKey === 1) {
      return (
        <BillingManagementDetails
          studioId={studioId}
          dateRange={dateRange}
          isDateRangeSelected={isDateRangeSelected}
        />
      );
    }
  };

  return (
    <div className="bi-child-container bi-withdrawal-container billing-management">
      <div className="top-box">
        <div className="top-left-box">
          <div className="top-tips">{getFormatMessage('bill_management')}</div>
          <div className="tab-btn-box">
            <div
              className={classNames(
                'tab-btn-item',
                tabKey === 0 ? 'tab-btn-item-active' : ''
              )}
              onClick={() => changeTabKey(0)}
            >
              {getFormatMessage('bill_management_overview')}
            </div>
            <div
              className={classNames(
                'tab-btn-item',
                tabKey === 1 ? 'tab-btn-item-active' : ''
              )}
              onClick={() => changeTabKey(1)}
            >
              {getFormatMessage('bill_management_details')}
            </div>
          </div>
        </div>
        <div className="date-picker-box">
          <DatePicker
            onChange={handleDateChange}
            picker="month"
            defaultValue={moment().subtract(1, 'months')}
            dropdownClassName="fee-data-dropdown"
            className="overview-date-picker"
            monthCellRender={(date) => {
              return `${moment(date).format('MM')}`; // 修改中文显示为数字
            }}
          />
        </div>
      </div>
      {renderOverview()}
      {renderDetails()}
    </div>
  );
};
